import type { SVGProps } from 'react';
const SvgLocalConvenienceStore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#local_convenience_store_svg__a)">
      <path
        fill="currentColor"
        d="M19 7V4H5v3H2v13h8v-4h4v4h8V7h-3Zm-8 3H9v1h2v1H8V9h2V8H8V7h3v3Zm5 2h-1v-2h-2V7h1v2h1V7h1v5Z"
      />
    </g>
    <defs>
      <clipPath id="local_convenience_store_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLocalConvenienceStore;
